var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPower75(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.01312V4.94415H11.1723V7.01312H11.9999Z",
    fill: "#C7CAC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.250072 8.59523V3.40793C0.250072 3.26441 0.366349 3.14813 0.509865 3.14813L10.6627 3.14813C10.8062 3.14813 10.9225 3.26441 10.9225 3.40793V8.59523C10.9225 8.73875 10.8062 8.85503 10.6627 8.85503H0.509865C0.366349 8.85503 0.250072 8.73875 0.250072 8.59523Z",
    fill: "#E7ECED",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.40002L0.755436 3.40002C0.476256 3.40002 0.25 3.59121 0.25 3.82712V8.17293C0.25 8.40884 0.476256 8.60002 0.755436 8.60002H8.25V3.40002Z",
    fill: "#6FCF97"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower75);
export default __webpack_public_path__ + "static/media/power-75.e194965b5d5b843c6db053a5a1559280.svg";
export { ForwardRef as ReactComponent };